import customemail from "../../../../assets/images/docs/forms/customemail.png";
import * as React from 'react';
export default {
  customemail,
  React
};